﻿export class OpenWritableWorkItemRequested {
    constructor(public workItemId: string, public stepFilter: string, public closeWhenComplete: boolean) { }

    static eventName() { return 'OpenWritableWorkItemRequested'; }

    eventName = OpenWritableWorkItemRequested.eventName;
}